import React, { useState } from "react";
import { usePartnersStore } from "../../stores/partnersStore";
import {
  SearchBar,
  RefreshButton,
  FilterModal,
  FilterButton,
  ToggleFilterCheckbox,
  PermissionWrapper,
} from "components";

// Компонент заголовку сторінки "Продукція партнерів"
const PartnersHeader = () => {
  // Отримуємо необхідні дані та дії зі стору
  const isLoading = usePartnersStore((state) => state.isLoading);
  const fetchPartners = usePartnersStore((state) => state.fetchPartners);
  const filters = usePartnersStore((state) => state.filters);
  const applyFilters = usePartnersStore((state) => state.applyFilters);
  const setSearch = usePartnersStore((state) => state.setSearch);
  const setIsFull = usePartnersStore((state) => state.setIsFull);
  const partnerTypes = usePartnersStore((state) => state.partnerTypes);
  const partnerProperties = usePartnersStore((state) => state.partnerProperties);

  // Локальний стан для керування видимістю модального вікна фільтрів
  const [isFilterOpen, setFilterOpen] = useState(false);

  return (
    <div className="partnerspage-title">
      <div className="partnerspage-title-line">
        <div className="title-container">
          <RefreshButton onRefresh={fetchPartners} disabled={isLoading} />
          <h3>Товари партнерів</h3>

          <div className="search-container">
            <SearchBar value={filters.search} onSearch={(value) => setSearch(value)} />
            <FilterButton
              onClick={() => setFilterOpen(true)}
              isActive={!!filters.type_id || !!filters.property_id}
            />
            <FilterModal
              isOpen={isFilterOpen}
              onClose={() => setFilterOpen(false)}
              onApply={applyFilters}
              filters={[
                {
                  id: "type_id",
                  label: "Тип продукції",
                  options: partnerTypes,
                  value: filters.type_id,
                  placeholder: "Всі типи",
                  valueKey: "id",
                  labelKey: "name",
                },
                {
                  id: "property_id",
                  label: "Тип ціни",
                  options: partnerProperties,
                  value: filters.property_id,
                  placeholder: "Всі типи оплати",
                  valueKey: "id",
                  labelKey: "name",
                },
              ]}
            />
          </div>
        </div>
        <PermissionWrapper requiredPermission="partners:edit">
          <ToggleFilterCheckbox
            id="partners-is-full-toggle"
            label="Показати неактивні"
            checked={filters.is_full}
            onChange={(e) => setIsFull(e.target.checked)}
          />
        </PermissionWrapper>
      </div>
    </div>
  );
};

export default PartnersHeader;
